<dashboardnav>

  <cradua-subgroup
  [divestmentstatuss]="divestmentstatuss$ | async"
  [groups]="groups$ | async"
  [subgroups]="subgroups$ | async"

  (changeEmit)="onSubmitSubGroup($event)"
  (deleteEvent)="onDeleteSubGroup($event)"
  *ngIf="
  !(isLoadingDivestmentStatus$ | async ) &&
  !(isLoadingGroup$ | async ) &&
  !(isLoadingSubGroup$ | async )
  "
  >
  </cradua-subgroup>

  <mrsoftapps-epims-reference-spinner
  *ngIf="
  (isLoadingDivestmentStatus$ | async ) ||
  (isLoadingGroup$ | async ) ||
  (isLoadingSubGroup$ | async )
  "
>
  </mrsoftapps-epims-reference-spinner>
</dashboardnav>
